import React from "react";
import styled, { createGlobalStyle } from "styled-components";
import { normalize } from "styled-normalize";
import { connect } from "react-redux";
import { Input, Row, Col, Select } from "antd";
import { withNamespaces } from "react-i18next";
import { fetchConfig, setConfig } from "./redux/actions/configActions";
import RouteTable from "./components/RouteTable";
import { socketClient, SOCKET_EVENTS } from "./socket/connection";

interface AppProps extends React.Props<any> {
  onLoad?: any;
  config: any;
}
interface AppState {
  config: any;
}
const GlobalStyle = createGlobalStyle`
    ${normalize}
    .ant-modal-body {overflow:hidden}    
`;

const MiddleLabel = styled.span<any>`
  display: inline-block;
  text-align: center;
  width: 100%;
`;

const mapStateToProps = state => ({
  ...state.config
});

const mapDispatchToProps = dispatch => ({
  onLoad: () => dispatch(fetchConfig()),
  saveConfig: data => dispatch(setConfig(data))
});

class App extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      config: {}
    };
  }
  componentDidMount() {
    this.fetchConfig();
    // use socket to refresh
    socketClient().on(SOCKET_EVENTS.CHANGE_CONFIG, this.fetchConfig);
  }

  componentWillReceiveProps(nextProps) {
    this.setState(
      Object.assign({}, this.state, {
        config: nextProps.config
      })
    );
  }

  fetchConfig = () => {
    this.props.onLoad();
  };

  saveConfigRoute(data) {
    //first set config and then get config
    this.props.saveConfig(data);
  }

  render() {
    const mockFileNameChange = e => {
      this.setState({
        config: Object.assign({}, this.state.config, {
          mockFileName: e.target.value
        })
      });
    };
    const { t, i18n } = this.props;
    const changeLanguage = lng => {
      i18n.changeLanguage(lng);
    };

    return (
      <React.Fragment>
        <GlobalStyle />
        <div className="App">
          <Row>
            <Col span={18}>
              <h1>{t("title")}</h1>
            </Col>
            <Col span={4} style={{ lineHeight: "80px" }}>
              <span style={{ marginRight: 8 }}>{t("txt.language")}:</span>
              <Select defaultValue="en" onChange={changeLanguage}>
                <Select.Option value="en">{t("txt.english")}</Select.Option>
                <Select.Option value="zh-CN">{t("txt.chinese")}</Select.Option>
              </Select>
            </Col>
            <Col span={2}  style={{marginTop:32}}>
              <a
          
                href="https://github.com/brizer/http-mocker"
                target="_blank"
              >
                <span>
                  <i aria-label="图标: github">
                    <svg
                      viewBox="64 64 896 896"
                      focusable="false"
                      data-icon="github"
                      width="1em"
                      height="1em"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path d="M511.6 76.3C264.3 76.2 64 276.4 64 523.5 64 718.9 189.3 885 363.8 946c23.5 5.9 19.9-10.8 19.9-22.2v-77.5c-135.7 15.9-141.2-73.9-150.3-88.9C215 726 171.5 718 184.5 703c30.9-15.9 62.4 4 98.9 57.9 26.4 39.1 77.9 32.5 104 26 5.7-23.5 17.9-44.5 34.7-60.8-140.6-25.2-199.2-111-199.2-213 0-49.5 16.3-95 48.3-131.7-20.4-60.5 1.9-112.3 4.9-120 58.1-5.2 118.5 41.6 123.2 45.3 33-8.9 70.7-13.6 112.9-13.6 42.4 0 80.2 4.9 113.5 13.9 11.3-8.6 67.3-48.8 121.3-43.9 2.9 7.7 24.7 58.3 5.5 118 32.4 36.8 48.9 82.7 48.9 132.3 0 102.2-59 188.1-200 212.9a127.5 127.5 0 0 1 38.1 91v112.5c.8 9 0 17.9 15 17.9 177.1-59.7 304.6-227 304.6-424.1 0-247.2-200.4-447.3-447.5-447.3z"></path>
                    </svg>
                  </i>
                </span>
                GitHub
              </a>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <MiddleLabel>{t("mockFileName")}</MiddleLabel>
            </Col>
            <Col span={8}>
              <Input
                disabled={true}
                value={this.state.config.mockFileName}
                onChange={mockFileNameChange}
              />
            </Col>
          </Row>
          <div className="table" style={{ margin: "20px" }}>
            <RouteTable
              onGet={this.fetchConfig.bind(this)}
              routes={this.state.config.routes}
              onSave={this.saveConfigRoute.bind(this)}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default withNamespaces("translation")(
  connect(mapStateToProps, mapDispatchToProps)(App)
);
